export default class FactureAvoirFactClientController {

    static $inject = [
        '$scope',
        '$state',
        '$stateParams',
        'AvoirsService',
        'notification',
        'ModalService',
        '$uibModal',
        'moment',
        '$translate'
    ];

    constructor($scope, $state, $stateParams, AvoirsService, notification, ModalService, $uibModal, moment, $translate) {
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.AvoirsService = AvoirsService;
        this.notification = notification;
        this.ModalService = ModalService;
        this.$uibModal = $uibModal;
        this.moment = moment;
        this.$translate = $translate;
    }

    async $onInit() {
        if (!this.idClients) {
            this.createAvoirRefact();
            return;
        }
        this.ticketSelecteds = this.avoirResult.ticketRefacts.filter((element) => element.isDelete);
        this.nbStep = this.idClients.length;
        this.step = 0;
        this.getTicketsClient();
        this.dateFacture = this.moment().format('DD/MM/YYYY');
    }

    getDateFacture() {
        for (let i = 0; i < this.ticketClients.length; i++) {
            const element = this.ticketClients[i];
            if (element.isDelete) {
                element.deleteOption.dateFacture = this.dateFacture;
            }
        } 
    }

    getTicketsClient() {
        let clientSelected = this.idClients[this.step];
        this.ticketClients = this.ticketSelecteds.filter((element) => element.deleteOption.idClient == clientSelected);
        this.title = this.ticketClients[0].client;  
        this.buttonTitle = this.$translate.instant('SUIVANT');
        if (this.step+1 >= this.nbStep) {
            this.buttonTitle = this.$translate.instant('VALIDER');
        }
    }

    nextClient(isFacture) {
        if (isFacture)
            this.getDateFacture();
        this.step++;
        if (this.nbStep == this.step) {
            this.createAvoirRefact();
        }
        else {
            this.getTicketsClient();
        }
    }

    async createAvoirRefact() {
        try {
            this.startLoading();
            this.avoirResult.dateValorisation = this.date;
            const recap = await this.AvoirsService.createAvoir(this.avoirResult); 
            this.modalInstance.close();  
            this.$uibModal.open({
                template:
                    '<facture-avoir-recap recap="$ctrl.recap" modal-instance="$ctrl.uibModalInstance"></facture-avoir-recap>',
                controller: [
                    '$uibModalInstance',
                    function ($uibModalInstance) {
                        var $ctrl = this;
                        $ctrl.recap = recap;
                        $ctrl.uibModalInstance = $uibModalInstance;
                    },
                ],
                controllerAs: '$ctrl',
                size: 'l',
                backdrop: false
            }); 
        } catch (ex) {
            this.notification.error(ex.data);
        } finally {
            this.stopLoading();
        }
    }

    async annuler() {
        this.modalInstance.close();
        if (this.avoirResult) {
            await this.AvoirsService.deleteTicketFictifs(this.avoirResult.idTickets);
        }
    }

    startLoading() {
        this.loading = true;
    }

    stopLoading() {
        this.loading = false;
    }
}
